export const TOAST_CONFIG = {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
}

export const TOAST_DEFAULT = {
    ERROR: 'common:toast.error',
    SUCCESS: 'common:toast.success',
    UPDATE_SUCCESS: 'common:toast.updateSuccess'
}

export const TOAST_POSITION = {
    topCenter: 'top-center',
    topRight: 'top-right',
    bottomLeft: 'bottom-left'
}